import xdcImg from "../assets/img/xdc.png";
import ethImg from "../assets/img/eth.png";
import solanaIcon from "../assets/img/solanaIcon.png";
import bitCoinImg from "../assets/img/bitcoinIcon.svg";
import xrpImg from "../assets/img/xrpIcon.png";

export const SubPath = "/build";

export const RemoveExpo = (x) => {
  var data = String(x).split(/[eE]/);
  if (data.length === 1) return data[0];

  var z = "",
    sign = x < 0 ? "-" : "",
    str = data[0].replace(".", ""),
    mag = Number(data[1]) + 1;

  if (mag < 0) {
    z = sign + "0.";
    while (mag++) z += "0";
    return z + str.replace(/^\-/, "");
  }
  mag -= str.length;
  while (mag--) z += "0";
  return str + z;
};

export const mainnetOptions = [
  {
    chainId: 50,
    value: "XDC Mainnet",
    label: (
      <div style={{ display: "flex", alignItems: "center" }}>
        <img
          src={xdcImg}
          style={{ height: "20px", width: "20px" }}
          alt="XDC Mainnet"
          className="select-options-img"
        />
        XDC Mainnet
      </div>
    ),
  },
  {
    chainId: 1,
    value: "Ethereum Mainnet",
    label: (
      <div style={{ display: "flex", alignItems: "center" }}>
        <img
          src={ethImg}
          style={{ height: "20px", width: "20px" }}
          alt="ETH Mainnet"
          className="select-options-img"
        />
        ETH Mainnet
      </div>
    ),
  },
  {
    chainId: 101,
    value: "Solana Mainnet",
    label: (
      <div style={{ display: "flex", alignItems: "center" }}>
        <img
          src={solanaIcon}
          style={{ height: "20px", width: "20px" }}
          alt="Solana Mainnet"
          className="select-options-img"
        />
        Solana Mainnet
      </div>
    ),
  },
  {
    chainId: 0,
    value: "Bitcoin Mainnet",
    label: (
      <div style={{ display: "flex", alignItems: "center" }}>
        <img
          src={bitCoinImg}
          style={{ height: "20px", width: "20px" }}
          alt="BTC Mainnet"
          className="select-options-img"
        />
        Bitcoin Mainnet
      </div>
    ),
  },
  {
    chainId: 144,
    value: "Xrp Mainnet",
    label: (
      <div style={{ display: "flex", alignItems: "center" }}>
        <img
          src={xrpImg}
          style={{ height: "20px", width: "20px" }}
          alt="XRP Mainnet"
          className="select-options-img"
        />
        XRP Mainnet
      </div>
    ),
  },
];

// Testnet options
export const testnetOptions = [
  {
    chainId: 51,
    value: "XDC Testnet",
    label: (
      <div style={{ display: "flex", alignItems: "center" }}>
        <img
          src={xdcImg}
          style={{ height: "20px", width: "20px" }}
          alt="XDC Testnet"
          className="select-options-img"
        />
        XDC Testnet (Apothem)
      </div>
    ),
  },
  {
    chainId: 11155111,
    value: "Ethereum Testnet",
    label: (
      <div style={{ display: "flex", alignItems: "center" }}>
        <img
          src={ethImg}
          style={{ height: "20px", width: "20px" }}
          alt="ETH Testnet"
          className="select-options-img"
        />
        ETH Testnet (Sepolia)
      </div>
    ),
  },
  {
    chainId: 103,
    value: "Solana Testnet",
    label: (
      <div style={{ display: "flex", alignItems: "center" }}>
        <img
          src={solanaIcon}
          style={{ height: "20px", width: "20px" }}
          alt="Solana Testnet"
          className="select-options-img"
        />
        Solana Testnet
      </div>
    ),
  },
  {
    chainId: 3,
    value: "Bitcoin Testnet",
    label: (
      <div style={{ display: "flex", alignItems: "center" }}>
        <img
          src={bitCoinImg}
          style={{ height: "20px", width: "20px" }}
          alt="BTC Testnet"
          className="select-options-img"
        />
        Bitcoin Testnet
      </div>
    ),
  },
  {
    chainId: 142,
    value: "XRP Testnet",
    label: (
      <div style={{ display: "flex", alignItems: "center" }}>
        <img
          src={xrpImg}
          style={{ height: "20px", width: "20px" }}
          alt="XRP Testnet"
          className="select-options-img"
        />
        XRP Testnet
      </div>
    ),
  },
];

export const options = mainnetOptions;
